/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PaperConsumption } from '../models/paper-consumption';
import { PaperHandlingPrice } from '../models/paper-handling-price';
import { PaperPrice } from '../models/paper-price';
import { UuiDv4 } from '../models/uui-dv-4';

@Injectable({
  providedIn: 'root',
})
export class PaperHandlingPriceService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listPaperHandlingPrices
   */
  static readonly ListPaperHandlingPricesPath = '/price-list-catalogs/{priceListCatalogId}/paper-extra-prices';

  /**
   * get list of PaperHandlingPrice for priceListCatalogId
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listPaperHandlingPrices()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPaperHandlingPrices$Response(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<PaperHandlingPrice>>> {

    const rb = new RequestBuilder(this.rootUrl, PaperHandlingPriceService.ListPaperHandlingPricesPath, 'get');
    if (params) {
      rb.path('priceListCatalogId', params.priceListCatalogId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PaperHandlingPrice>>;
      })
    );
  }

  /**
   * get list of PaperHandlingPrice for priceListCatalogId
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listPaperHandlingPrices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listPaperHandlingPrices(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;
  },
  context?: HttpContext

): Observable<Array<PaperHandlingPrice>> {

    return this.listPaperHandlingPrices$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<PaperHandlingPrice>>) => r.body as Array<PaperHandlingPrice>)
    );
  }

  /**
   * Path part for operation savePaperHandlingPrice
   */
  static readonly SavePaperHandlingPricePath = '/price-list-catalogs/{priceListCatalogId}/paper-extra-prices';

  /**
   * upsert PaperHandlingPrice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `savePaperHandlingPrice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  savePaperHandlingPrice$Response(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;
    body: PaperHandlingPrice
  },
  context?: HttpContext

): Observable<StrictHttpResponse<UuiDv4>> {

    const rb = new RequestBuilder(this.rootUrl, PaperHandlingPriceService.SavePaperHandlingPricePath, 'put');
    if (params) {
      rb.path('priceListCatalogId', params.priceListCatalogId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UuiDv4>;
      })
    );
  }

  /**
   * upsert PaperHandlingPrice
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `savePaperHandlingPrice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  savePaperHandlingPrice(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;
    body: PaperHandlingPrice
  },
  context?: HttpContext

): Observable<UuiDv4> {

    return this.savePaperHandlingPrice$Response(params,context).pipe(
      map((r: StrictHttpResponse<UuiDv4>) => r.body as UuiDv4)
    );
  }

  /**
   * Path part for operation getPaperConsumption
   */
  static readonly GetPaperConsumptionPath = '/price-list-catalogs/{priceListCatalogId}/paperConsumption';

  /**
   * get paperConsumption
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPaperConsumption()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaperConsumption$Response(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PaperConsumption>> {

    const rb = new RequestBuilder(this.rootUrl, PaperHandlingPriceService.GetPaperConsumptionPath, 'get');
    if (params) {
      rb.path('priceListCatalogId', params.priceListCatalogId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaperConsumption>;
      })
    );
  }

  /**
   * get paperConsumption
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPaperConsumption$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaperConsumption(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;
  },
  context?: HttpContext

): Observable<PaperConsumption> {

    return this.getPaperConsumption$Response(params,context).pipe(
      map((r: StrictHttpResponse<PaperConsumption>) => r.body as PaperConsumption)
    );
  }

  /**
   * Path part for operation updatePaperConsumption
   */
  static readonly UpdatePaperConsumptionPath = '/price-list-catalogs/{priceListCatalogId}/paperConsumption';

  /**
   * update paperConsumption
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePaperConsumption()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePaperConsumption$Response(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;
    body: PaperConsumption
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PaperConsumption>> {

    const rb = new RequestBuilder(this.rootUrl, PaperHandlingPriceService.UpdatePaperConsumptionPath, 'put');
    if (params) {
      rb.path('priceListCatalogId', params.priceListCatalogId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaperConsumption>;
      })
    );
  }

  /**
   * update paperConsumption
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePaperConsumption$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePaperConsumption(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;
    body: PaperConsumption
  },
  context?: HttpContext

): Observable<PaperConsumption> {

    return this.updatePaperConsumption$Response(params,context).pipe(
      map((r: StrictHttpResponse<PaperConsumption>) => r.body as PaperConsumption)
    );
  }

  /**
   * Path part for operation getPaperPrice
   */
  static readonly GetPaperPricePath = '/price-list-catalogs/{priceListCatalogId}/paperPrice';

  /**
   * get paperPrice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPaperPrice()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaperPrice$Response(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PaperPrice>> {

    const rb = new RequestBuilder(this.rootUrl, PaperHandlingPriceService.GetPaperPricePath, 'get');
    if (params) {
      rb.path('priceListCatalogId', params.priceListCatalogId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaperPrice>;
      })
    );
  }

  /**
   * get paperPrice
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPaperPrice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaperPrice(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;
  },
  context?: HttpContext

): Observable<PaperPrice> {

    return this.getPaperPrice$Response(params,context).pipe(
      map((r: StrictHttpResponse<PaperPrice>) => r.body as PaperPrice)
    );
  }

  /**
   * Path part for operation updatePaperPrice
   */
  static readonly UpdatePaperPricePath = '/price-list-catalogs/{priceListCatalogId}/paperPrice';

  /**
   * update paperPrice
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePaperPrice()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePaperPrice$Response(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;
    body: PaperPrice
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PaperPrice>> {

    const rb = new RequestBuilder(this.rootUrl, PaperHandlingPriceService.UpdatePaperPricePath, 'put');
    if (params) {
      rb.path('priceListCatalogId', params.priceListCatalogId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaperPrice>;
      })
    );
  }

  /**
   * update paperPrice
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePaperPrice$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePaperPrice(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;
    body: PaperPrice
  },
  context?: HttpContext

): Observable<PaperPrice> {

    return this.updatePaperPrice$Response(params,context).pipe(
      map((r: StrictHttpResponse<PaperPrice>) => r.body as PaperPrice)
    );
  }

  /**
   * Path part for operation getPaperHandlingPrice
   */
  static readonly GetPaperHandlingPricePath = '/price-list-catalogs/{priceListCatalogId}/paper-extra-prices/{id}';

  /**
   * get PaperHandlingPrice by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPaperHandlingPrice()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaperHandlingPrice$Response(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;

    /**
     * UUID of the PaperHandlingPrice to get
     */
    id: UuiDv4;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PaperHandlingPrice>> {

    const rb = new RequestBuilder(this.rootUrl, PaperHandlingPriceService.GetPaperHandlingPricePath, 'get');
    if (params) {
      rb.path('priceListCatalogId', params.priceListCatalogId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PaperHandlingPrice>;
      })
    );
  }

  /**
   * get PaperHandlingPrice by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPaperHandlingPrice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPaperHandlingPrice(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;

    /**
     * UUID of the PaperHandlingPrice to get
     */
    id: UuiDv4;
  },
  context?: HttpContext

): Observable<PaperHandlingPrice> {

    return this.getPaperHandlingPrice$Response(params,context).pipe(
      map((r: StrictHttpResponse<PaperHandlingPrice>) => r.body as PaperHandlingPrice)
    );
  }

  /**
   * Path part for operation deletePaperHandlingPrice
   */
  static readonly DeletePaperHandlingPricePath = '/price-list-catalogs/{priceListCatalogId}/paper-extra-prices/{id}';

  /**
   * delete PaperHandlingPrice by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePaperHandlingPrice()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePaperHandlingPrice$Response(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;

    /**
     * UUID of the PaperHandlingPrice to delete
     */
    id: UuiDv4;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PaperHandlingPriceService.DeletePaperHandlingPricePath, 'delete');
    if (params) {
      rb.path('priceListCatalogId', params.priceListCatalogId, {});
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * delete PaperHandlingPrice by id
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePaperHandlingPrice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePaperHandlingPrice(params: {

    /**
     * UUID of the PriceListCatalogId
     */
    priceListCatalogId: UuiDv4;

    /**
     * UUID of the PaperHandlingPrice to delete
     */
    id: UuiDv4;
  },
  context?: HttpContext

): Observable<void> {

    return this.deletePaperHandlingPrice$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
